import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { medicalExamination } from "../../../model/medicalexamination";

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOAD_PENDING: {
            return {
                ...state,
                medicalExaminations: [],
                isLoadingMex: true,
            }
        }
        case Keys.LOAD_FULFILLED: {
            let p: Array<medicalExamination> = action.payload;
            return {
                ...state,
                medicalExaminations: p,
                isLoadingMex: false,
            }
        }
        case Keys.LOAD_REJECTED: {
            return {
                ...state,
                medicalExaminations: [],
                isLoadingMex: false,
            }
        }
        case Keys.LOADBYMEX_ID_PENDING: {
            return {
                ...state,
                selectedMedicalExamination: undefined,
                isLoadingMex: true,
            }
        }
        case Keys.LOADBYMEX_ID_FULFILLED: {
            let p: medicalExamination = action.payload;
            return {
                ...state,
                selectedMedicalExamination: p,
                isLoadingMex: false,
            }
        }
        case Keys.LOADBYMEX_ID_REJECTED: {
            return {
                ...state,
                selectedMedicalExamination: undefined,
                isLoadingMex: false,
            }
        }
        case Keys.VALIDATE_PENDING: {
            return {
                ...state,
                isLoadingMex: true,
            }
        }
        case Keys.VALIDATE_FULFILLED: {
            const p: medicalExamination = action.payload;
            const next = state.medicalExaminations.map((c, idx) => {
                if (c._id === p._id) {
                    return p;
                }
                else {
                    return c;
                }
            })
            return {
                ...state,
                medicalExaminations: next,
                isLoadingMex: false,
            }
        }
        case Keys.VALIDATE_REJECTED: {
            return {
                ...state,
                isLoadingMex: false,
            }
        }
        case Keys.DELETE_PENDING: {
            return {
                ...state,
                isLoadingMex: true,
            }
        }
        case Keys.DELETE_FULFILLED: {
            const p: medicalExamination = action.payload;
            p.isDeleted = true;
            const next = state.medicalExaminations.map((c, idx) => {
                if (c._id === p._id) {
                    return p;
                }
                else {
                    return c;
                }
            })
            return {
                ...state,
                medicalExaminations: next,
                // newMedicalExamination: p,
                isLoadingMex: false,
            }
        }
        case Keys.DELETE_REJECTED: {
            return {
                ...state,
                isLoadingMex: false,
            }
        }
        case Keys.ADD_PENDING: {
            return {
                ...state,
                isLoadingMex: true,
            }
        }
        case Keys.ADD_FULFILLED: {
            const p: medicalExamination = action.payload;
            // console.log("----------------------------------------------------------------------")
            // console.log("Keys.ADD_FULFILLED medicalExamination:", p)
            return {
                ...state,
                selectedMedicalExamination: p,
                isLoadingMex: false,
            }
        }
        case Keys.ADD_REJECTED: {
            return {
                ...state,
                isLoadingMex: false,
            }
        }
        case Keys.RESETNEW: {
            console.log("---------------------------------------------------------------------- RESET NEW")
            return {
                ...state,
                selectedMedicalExamination: undefined,
            }
        }
        case Keys.LOADBYUSER_PENDING: {
            return {
                ...state,
                medicalExaminations: [],
                isLoadingMex: true,
            }
        }
        case Keys.LOADBYUSER_FULFILLED: {
            let p: Array<medicalExamination> = action.payload;
            return {
                ...state,
                medicalExaminations: p,
                isLoadingMex: false,
            }
        }
        case Keys.LOADBYUSER_REJECTED: {
            return {
                ...state,
                medicalExaminations: [],
                isLoadingMex: false,
            }
        }
        default:
            return state;




    }
}